import * as React from 'react';
import { SimpleDate, SimpleTimeRange } from '../../../../admin/components/date/TimeRange';
import './eventSummary.module.scss';
import { StepText } from '../../common/StepText';
import { EventDetails } from '../../../types/event';

type Props = {
    event: EventDetails;
    appliedPrice: number;
};
export const EventSummary = ({ event, appliedPrice }: Props) => {
    return (
        <StepText>
            {event.title}
            <br />
            日時: <SimpleDate date={event.starts_at} /> <SimpleTimeRange range={event} />
            <br />
            参加費:{' '}
            {appliedPrice > 0 ? (
                <span>
                    {appliedPrice.toLocaleString()}円（税込 {event.price_with_tax.toLocaleString()}円）
                </span>
            ) : (
                <span>無料</span>
            )}
        </StepText>
    );
};
